<template>
	<div>
		<!--New page-->
		<h1>Study Information</h1>

		<InputTextSingleLine
			question="Where your reviewer registered OR where do you intend to register it?"
			placeholder="e.g. https://www.crd.york.ac.uk/prospero/ , https://osf.io/"
			v-model="$tera.project.reviewerRegistered"
			questionMark="writeprotocol-1"
		/>

		<InputElDate
			question="What date was / will be the protocol registered?"
			placeholder="e.g. 15 April 2024"
			v-model="$tera.project.reviewProtocolDate"
			@update:value="$tera.project.reviewProtocolDate = $event"
			questionMark="writeprotocol-2"
		/>

		<InputSelectYesNo
			question="Do you want to cite us?"
			v-model="$tera.project.ifCite"
			questionMark="writeprotocol-3"
		/>

		<BasePreviewOutput :component="outputComponent" />
	</div>
</template>
<script>
import InputTextSingleLine from "@/components/InputTextSingleLine.vue";
import InputSelectYesNo from "@/components/InputSelectYesNo.vue";
import OutputStudyInformation from "./OutputStudyInformation.vue";

export default {
	name: "studyInformation",
	components: {
		InputTextSingleLine,
		InputSelectYesNo
	},
	data() {
		return {
			outputComponent: OutputStudyInformation
		};
	}
};
</script>
<style></style>
